<div class="tab-box">
  <div class="title-ind">
    <h1 class="title-tab">Transportistas</h1>
    <div class="stackedBarTitle">
      <canvas #stackedCanvasTitleTransportista></canvas>
    </div>
  </div>
    <div class="acciones-tabla">
      <app-input-tabla (keyup)="applyFilter($event)"></app-input-tabla>
      <div>
        <button class="boton-descarga" (click)="exportAsExcel()">
          <img class="boton-descarga__icon" src="../../../../assets/descargar.svg" />
          Descargar
        </button>
      </div>
    </div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <!-- <ng-container matColumnDef="id">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let transportista" (click)="openDetails(transportista.id)">{{ transportista.id }}</td>
      </ng-container> -->

      <ng-container matColumnDef="centro">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>CENTROS</th>
        <td mat-cell *matCellDef="let transportista" (click)="openDetails(transportista.id)"><ng-container *ngFor="let transportista of transportista.centros">{{transportista.nombre}}<br></ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >NOMBRE

          <!-- <mat-form-field appearance="outline">
            
            <mat-select name="nombre" placeholder="NOMBRE" class="filtro-tabla"  [(ngModel)]="selectedValue" multiple>
              <div class="boton-filtro" (click)="unselect()">Limpiar Filtros</div>
              <mat-option *ngFor="let transportista of transportistasFilter" [value]="transportista" #matOption (click)="selectTransportista(matOption)">
              {{transportista.nombre}}
              </mat-option>
    
            </mat-select>
          
          </mat-form-field> -->
    
        </th>
        <td mat-cell *matCellDef="let transportista" (click)="openDetails(transportista.id)">
          {{ transportista.nombre }}
        </td>
      </ng-container>
      <ng-container matColumnDef="cif">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>CIF</th>
        <td mat-cell *matCellDef="let transportista" (click)="openDetails(transportista.id)" >{{ transportista.cif }}</td>
      </ng-container>
      <!-- <ng-container matColumnDef="contacto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CONTACTO</th>
        <td mat-cell *matCellDef="let transportista" (click)="openDetails(transportista.id)">
          {{ transportista.nombreContacto }}
        </td>
      </ng-container> -->
      <!-- <ng-container matColumnDef="direccion.provincia">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>PROVINCIA -->
          <!-- <mat-form-field appearance="outline">
            <mat-select name="provincia" placeholder="PROVINCIA" class="filtro-tabla"  [(ngModel)]="selectedValue" multiple>
              <div class="boton-filtro" (click)="unselect()">Limpiar Filtros</div>
              <mat-option *ngFor="let transportista of transportistasSelect" [value]="transportista" #matOption (click)="selectTransportista(matOption)">
              {{transportista?.direccion?.provincia}}
              </mat-option>
    
            </mat-select>
          </mat-form-field> -->
        <!-- </th>
        <td mat-cell *matCellDef="let transportista" (click)="openDetails(transportista.id)">
          <div
            *ngIf="
              transportista.direccion && transportista.direccion.provincia;
              else elseBlock
            "
          >
            {{ transportista.direccion.provincia }}
          </div>
          <ng-template #elseBlock>-</ng-template>
        </td>
      </ng-container>
      <ng-container matColumnDef="direccion.ccaa">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CCAA -->
        
          <!-- <mat-form-field appearance="outline">
            <mat-select name="ccaa" placeholder="CCAA" class="filtro-tabla"  [(ngModel)]="selectedValue" multiple>
              <div class="boton-filtro" (click)="unselect()">Limpiar Filtros</div>
              <mat-option *ngFor="let transportista of transportistasSelect" [value]="transportista" #matOption (click)="selectTransportista(matOption)">
              {{transportista?.direccion?.ccaa}}
              </mat-option>
    
            </mat-select>
          </mat-form-field> -->
        <!-- </th>
        <td mat-cell *matCellDef="let transportista" (click)="openDetails(transportista.id)">
          <div
            *ngIf="
              transportista.direccion && transportista.direccion.ccaa;
              else elseBlock
            "
          >
            {{ transportista.direccion.ccaa }}
          </div>
          <ng-template #elseBlock>-</ng-template>
        </td>
      </ng-container> -->
      <ng-container matColumnDef="indicadores">
        <th mat-header-cell *matHeaderCellDef>INDICADORES</th>
        <td mat-cell *matCellDef="let transportista">
          <div class="stackedBar">
            <canvas #stackedCanvasTransportista id="{{transportista.id}}"></canvas>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10,15,20]" (click)="getTransportistasByCliente()"></mat-paginator>
  </div>
  
